import React from 'react';
// Mui components
import { Box, Typography } from '@mui/material';
// Hooks
import { toCamelCaseFirstWord } from '../../../utils/Hooks/textFormatted';

const EspecialidadesList = ({ especialidades, separator = ' | ' }) => (
  <Box sx={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', wordBreak: 'break-word' }}>
    {especialidades.length > 0 ? (
      especialidades.map((especialidad, index) => (
        <Box key={index} sx={{ display: 'flex', gap: '0.5rem' }}>
          <Typography component="span" variant="h5">
            {toCamelCaseFirstWord(especialidad.descripcion)}
          </Typography>
          <Typography component="span" variant="h5">
            {index < especialidades.length - 1 && separator}
          </Typography>
        </Box>
      ))
    ) : (
      <Typography component="span" variant="h5">
        -
      </Typography>
    )}
  </Box>
);

export default EspecialidadesList;
